import { render, staticRenderFns } from "./default.vue?vue&type=template&id=182dce38&scoped=true&"
var script = {}
import style0 from "./default.vue?vue&type=style&index=0&id=182dce38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182dce38",
  null
  
)

export default component.exports